// gsap ScrollTrigger
gsap.registerPlugin(ScrollTrigger);
document.addEventListener("DOMContentLoaded", function () {
  // 全局渐显
  function animateFrom(elem, direction) {
    direction = direction || 1;
    var x = 0,
      y = direction * 100;
    elem.style.transform = "translate(" + x + "px, " + y + "px)";
    elem.style.opacity = "0";
    gsap.fromTo(
      elem,
      { x: x, y: y, autoAlpha: 0 },
      {
        duration: 2,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "expo",
        overwrite: "auto",
      }
    );
  }
  function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 });
  }
  gsap.utils.toArray(".gs_reveal").forEach(function (elem) {
    hide(elem); // assure that the element is hidden when scrolled into view
    ScrollTrigger.create({
      trigger: elem,
      onEnter: function () {
        animateFrom(elem);
      },
      onEnterBack: function () {
        animateFrom(elem, -1);
      },
      onLeave: function () {
        hide(elem);
      }, // assure that the element is hidden when scrolled into view
    });
  });
  // if PC and Mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }
  if (isMobile()) {
  } else {
    NASVideo();
    PrivacyProtection();
  }
  //   NAS video全屏
  function NASVideo() {
    const NASVideo = gsap.timeline({
      scrollTrigger: {
        trigger: ".NAS_video",
        start: "top top",
        pin: true,
        scrub: true,
        end: "+=100%",
      },
    });
    NASVideo.to(".NAS_video .ug-custom-video", {
      ease: "none",
      transform: "scale(1)",
    });
    NASVideo.to(".NAS_video .video_bg", {
      ease: "none",
      autoAlpha: 1,
    });
    NASVideo.to(".NAS_video .nas-video-content", {
      ease: "none",
      autoAlpha: 1,
    });
    NASVideo.to(".NAS_video .video_bx", {
      ease: "none",
      autoAlpha: 1,
    });
  }
  //   隐私保护全屏
  function PrivacyProtection() {
    const PrivacyProtection = gsap.timeline({
      scrollTrigger: {
        trigger: ".NAS_PrivacyProtection",
        start: "top top",
        pin: true,
        scrub: true,
        end: "+=100%",
      },
    });
    PrivacyProtection.to(".NAS_PrivacyProtection .top_img", {
      ease: "none",
      transform: "translateY(0) scale(1)",
    });
    PrivacyProtection.to(".NAS_PrivacyProtection .text", {
      ease: "none",
      autoAlpha: 1,
    });
    PrivacyProtection.to(".NAS_PrivacyProtection .bottom_list", {
      ease: "none",
      autoAlpha: 1,
    });
  }
});
